var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearpricing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #b29d7b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,.6C22.7.6.6,22.7.6,50s22.1,49.4,49.4,49.4,49.4-22.1,49.4-49.4S77.3.6,50,.6ZM66.1,70.3h-31.9v-5.7c3.7-1.6,7.8-5.5,7.8-10.3s0-1.8-.2-2.8h-6.8v-7.3h5.6c-.3-1.7-.5-3.7-.5-5.7,0-8.8,6.4-14.6,15.8-14.6s6.7.8,8.2,1.7l-1.7,8c-1.4-.7-3.3-1.3-5.9-1.3-5,0-6.5,3.2-6.5,6.6s.3,3.5.7,5.2h9.6v7.3h-8.7c0,1.7-.1,3.3-.6,4.9-.7,1.8-1.8,3.5-3.4,5h0c0,.1,18.7.1,18.7.1v8.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearpricing);
export default __webpack_public_path__ + "static/media/clearpricing.ec52f0a8831046918c8d713146fd5590.svg";
export { ForwardRef as ReactComponent };